import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    userstatus: "-1",
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
const WELLSUITE = '../../WsWebServiceWellSuite/';
// Participant/Misc/Types/Get/{AuthToken}/	
// Participant/Misc/Type/Update/{AuthToken}/{ParticipantRaceGuid}/{RaceName}/{RaceDescription}/	
// Participant/Misc/Type/Delete/{AuthToken}/{ParticipantRaceGuid}/	
// Participant/Misc/Type/Create/{AuthToken}/{RaceName}/{RaceDescription}/	
export const fetchTermsandConditions = createAsyncThunk('termsandconditions/get', async (incomingVariable, thunkAPI) => {
    
    try {
        const response = await axios.get(WELLSUITE + "GetViewInstance/" + incomingVariable.authToken + "/B8D7E7DC-CBF7-488F-B866-71125D6C6F14"+'/')
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {
    
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const fetchTCStatus = createAsyncThunk('tcstatus/get', async (incomingVariable, thunkAPI) => {
    
    try {
        const response = await axios.get(PLATFORM + "Participant/TCStatus/Get/" + incomingVariable.authToken + "/")
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {
    
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const updateTCStatus = createAsyncThunk('termsandconditions/update', async (incomingVariable, thunkAPI) => {
    
    try {
        const response = await axios.post(PLATFORM + "Participant/TCStatus/Update/"  + incomingVariable.authToken + "/" + incomingVariable.status + "/")
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {
    
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

const termsAndConditionsSlice = createSlice({
    name: 'termsandconditions',
    initialState,
    reducers: {
        termsandconditionsClear(state, action) {
            state.entities = initialState.entities
            state.status = "idle"
        }
    },
    extraReducers(builder) {
        builder
            //
            .addCase(fetchTermsandConditions.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchTermsandConditions.fulfilled, (state, action) => {
                state.status = 'success'
                state.entities = action.payload.Info[0].ViewInstanceData[0]
            })
            .addCase(fetchTermsandConditions.rejected, (state, action) => {
                state.error = action.error.message
                
            })
            .addCase(fetchTCStatus.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchTCStatus.fulfilled, (state, action) => {
                state.status = 'success'
                state.userstatus = action.payload.Info[0].ParticipantTCStatus
            })
            .addCase(fetchTCStatus.rejected, (state, action) => {
                state.error = action.error.message
                
            })
            .addCase(updateTCStatus.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(updateTCStatus.fulfilled, (state, action) => {
                state.status = 'success'
                state.userstatus = action.payload.Info[0].ParticipantTCStatus
            })
            .addCase(updateTCStatus.rejected, (state, action) => {
                state.error = action.error.message
                
            })
            
    }
})


export default termsAndConditionsSlice.reducer

export const { termsandconditionsClear } = termsAndConditionsSlice.actions

export const selectTCEntities = (state) => state.termsandconditions.entities
export const selectTCStatus = (state) => state.termsandconditions.status
export const selectTCError = (state) => state.termsandconditions.error
export const selectTCUserStatus = (state) => state.termsandconditions.userstatus